import { Routes } from '@angular/router';
import {
  PortalShellComponent,
  NavItem,
  PortalUser,
} from './shared/portal-shell.component';
import { roleGuard } from '../core/guards/auth.guard';

// ── SVG icon strings ──────────────────────────────────
const ICONS = {
  grid: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>`,
  folder: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>`,
  filePlus: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M12 18v-6"/><path d="M9 15h6"/></svg>`,
  bell: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>`,
  user: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>`,
  shield: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>`,
  logout: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>`,
  table: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18"/><path d="M9 21V9"/></svg>`,
  bar: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M18 20V10"/><path d="M12 20V4"/><path d="M6 20v-6"/></svg>`,
  settings: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="3"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>`,
  briefcase: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>`,
  doc: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M16 13H8"/><path d="M16 17H8"/></svg>`,
  calendar: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4"/><path d="M8 2v4"/><path d="M3 10h18"/></svg>`,
  scale: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M16 16l3-8 5.214 0"/><path d="M2 16l3-8 5.214 0"/><path d="M7 21h10"/><path d="M12 3v18"/></svg>`,
};

// ── Nav configs ───────────────────────────────────────
const CITIZEN_NAV: NavItem[] = [
  {
    sectionLabel: 'Main',
    label: 'Dashboard',
    icon: ICONS.grid,
    route: 'dashboard',
  },
  { label: 'My Cases', icon: ICONS.folder, route: 'cases', activeFor: ['/portal/citizen/cases/'] },
  { label: 'File New Case', icon: ICONS.filePlus, route: 'file' },
  {
    sectionLabel: 'Account',
    label: 'Notifications',
    icon: ICONS.bell,
    badge: 3,
  },
  { label: 'Profile', icon: ICONS.user },
  { label: 'Security', icon: ICONS.shield },
  { label: 'Sign out', icon: ICONS.logout, isSignOut: true },
];

const REGISTRAR_NAV: NavItem[] = [
  {
    sectionLabel: 'Main',
    label: 'Intake Queue',
    icon: ICONS.table,
    route: 'queue',
  },
  { label: 'Statistics', icon: ICONS.bar, route: 'stats' },
  { sectionLabel: 'Account', label: 'Settings', icon: ICONS.settings },
  { label: 'Sign out', icon: ICONS.logout, isSignOut: true },
];

const ADMIN_NAV: NavItem[] = [
  { sectionLabel: 'Operations', label: 'Dashboard',  icon: ICONS.grid,     route: 'dashboard'  },
  { label: 'Analytics',  icon: ICONS.bar,      route: 'analytics' },
  { label: 'Users',      icon: ICONS.user,     route: 'users'     },
  { label: 'Payments',   icon: ICONS.table,    route: 'payments'  },
  { label: 'Audit Log',  icon: ICONS.shield,   route: 'audit'     },
  { sectionLabel: 'Account', label: 'Sign out', icon: ICONS.logout, isSignOut: true },
];

const JUDGE_NAV: NavItem[] = [
  {
    sectionLabel: 'Judicial',
    label: 'Assigned Cases',
    icon: ICONS.briefcase,
    route: 'cases',
    badge: 12,
    activeFor: ['/portal/judge/brief'],
  },
  // Procedural Brief is a per-case detail view (reached by selecting a case),
  // not a standalone section — hidden from the sidebar to avoid a dead landing.
  // { label: 'Procedural Brief', icon: ICONS.doc, route: 'brief' },
  { label: 'Hearings', icon: ICONS.calendar, route: 'hearings' },
  { label: 'Pending Rulings', icon: ICONS.scale, route: 'rulings', badge: 3 },
  {
    sectionLabel: 'Account',
    label: 'Sign out',
    icon: ICONS.logout,
    isSignOut: true,
  },
];

// ── Users (mock — will come from auth state later) ────
const CITIZEN_USER: PortalUser = {
  name: 'Oluwatobi Adewale',
  role: 'Citizen',
  initials: 'OA',
  id: 'N-4829371',
};
const REGISTRAR_USER: PortalUser = {
  name: 'Funke Adeyemi',
  role: 'Registrar',
  initials: 'FA',
  id: 'IPPIS-447821',
};
const JUDGE_USER: PortalUser = {
  name: 'Hon. J. B. Adewale',
  role: 'Judge · Court 9',
  initials: 'BA',
};

const ADMIN_USER: PortalUser = {
  name: 'Emeka Obi',
  role: 'System Admin',
  initials: 'EO',
  id: 'SYS-001',
};

// ── Routes ────────────────────────────────────────────
export const portalRoutes: Routes = [
  // ── Citizen ──
  {
    path: 'citizen',
    component: PortalShellComponent,
    canActivate: [roleGuard],
    data: {
      role: 'citizen',
      portalTitle: 'Citizen Portal',
      navItems: CITIZEN_NAV,
      user: CITIZEN_USER,
    },
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./citizen/dashboard/citizen-dashboard.component').then(
            (m) => m.CitizenDashboardComponent,
          ),
        data: { breadcrumb: 'Dashboard' },
      },
      {
        path: 'cases',
        loadComponent: () =>
          import('./citizen/cases/citizen-cases.component').then(
            (m) => m.CitizenCasesComponent,
          ),
        data: { breadcrumb: 'My Cases' },
      },
      {
        path: 'cases/:id',
        loadComponent: () =>
          import('./citizen/case-detail/citizen-case-detail.component').then(
            (m) => m.CitizenCaseDetailComponent,
          ),
        data: { breadcrumb: 'Case Detail' },
      },
      {
        path: 'cases/:id/correction',
        loadComponent: () =>
          import('./citizen/correction/citizen-correction.component').then(
            (m) => m.CitizenCorrectionComponent,
          ),
        data: { breadcrumb: 'Upload Missing Document' },
      },
      {
        path: 'file',
        loadComponent: () =>
          import('./citizen/filing/citizen-filing.component').then(
            (m) => m.CitizenFilingComponent,
          ),
        data: { breadcrumb: 'File New Case' },
      },
    ],
  },

  // ── Registrar ──
  {
    path: 'registrar',
    component: PortalShellComponent,
    canActivate: [roleGuard],
    data: {
      role: 'registrar',
      portalTitle: 'Registrar Portal',
      navItems: REGISTRAR_NAV,
      user: REGISTRAR_USER,
    },
    children: [
      { path: '', redirectTo: 'queue', pathMatch: 'full' },
      {
        path: 'queue',
        loadComponent: () =>
          import('./registrar/queue/registrar-queue.component').then(m => m.RegistrarQueueComponent),
        data: { breadcrumb: 'Intake Queue' },
      },
      {
        path: 'stats',
        loadComponent: () =>
          import('./registrar/stats/registrar-stats.component').then(m => m.RegistrarStatsComponent),
        data: { breadcrumb: 'Statistics' },
      },
    ],
  },

  // ── Judge ──
  {
    path: 'judge',
    component: PortalShellComponent,
    canActivate: [roleGuard],
    data: { role: 'judge', portalTitle: 'Judge Portal', navItems: JUDGE_NAV, user: JUDGE_USER },
    children: [
      { path: '', redirectTo: 'cases', pathMatch: 'full' },
      {
        path: 'cases',
        loadComponent: () => import('./judge/cases/judge-cases.component').then(m => m.JudgeCasesComponent),
        data: { breadcrumb: 'Assigned Cases' },
      },
      {
        path: 'brief',
        loadComponent: () => import('./judge/brief/judge-brief.component').then(m => m.JudgeBriefComponent),
        data: { breadcrumb: 'Procedural Brief' },
      },
      {
        path: 'hearings',
        loadComponent: () => import('./judge/hearings/judge-hearings.component').then(m => m.JudgeHearingsComponent),
        data: { breadcrumb: 'Hearings' },
      },
      {
        path: 'rulings',
        loadComponent: () => import('./judge/rulings/judge-rulings.component').then(m => m.JudgeRulingsComponent),
        data: { breadcrumb: 'Pending Rulings' },
      },
    ],
  },

  // ── Admin ──
  {
    path: 'admin',
    component: PortalShellComponent,
    canActivate: [roleGuard],
    data: { role: 'admin', portalTitle: 'Admin', navItems: ADMIN_NAV, user: ADMIN_USER },
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', loadComponent: () => import('./admin/dashboard/admin-dashboard.component').then(m => m.AdminDashboardComponent),  data: { breadcrumb: 'Dashboard' } },
      { path: 'analytics', loadComponent: () => import('./admin/analytics/admin-analytics.component').then(m => m.AdminAnalyticsComponent),  data: { breadcrumb: 'Analytics' } },
      { path: 'users',     loadComponent: () => import('./admin/users/admin-users.component').then(m => m.AdminUsersComponent),              data: { breadcrumb: 'Users'     } },
      { path: 'payments',  loadComponent: () => import('./admin/payments/admin-payments.component').then(m => m.AdminPaymentsComponent),     data: { breadcrumb: 'Payments'  } },
      { path: 'audit',     loadComponent: () => import('./admin/audit/admin-audit.component').then(m => m.AdminAuditComponent),              data: { breadcrumb: 'Audit Log' } },
    ],
  },
];
